import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { coordinates: '_geoCoordinates' };
var _bookingsSettings = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    siteProperties: '_siteProperties',
};
var _geoCoordinates = { latitude: 'DOUBLE', longitude: 'DOUBLE' };
var _getBookingsSettingsRequest = {};
var _getBookingsSettingsResponse = { bookingsSettings: '_bookingsSettings' };
var _siteProperties = { address: '_address' };
var _updateBookingsSettingsRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    bookingsSettings: '_bookingsSettings',
};
var _updateBookingsSettingsResponse = {
    bookingsSettings: '_bookingsSettings',
};
function resolveWixBookingsSettingsV2BookingsSettingsServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/bookings-settings',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/bookings-settings',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/bookings-settings',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/bookings-settings',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/bookings-settings',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/bookings-settings',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/bookings-settings',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/bookings-settings',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/bookings-settings',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves a BookingsSettings. */
export function getBookingsSettings(payload) {
    var _a = serializer(_getBookingsSettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getBookingsSettingsResponse, {
        _address: _address,
        _bookingsSettings: _bookingsSettings,
        _geoCoordinates: _geoCoordinates,
        _siteProperties: _siteProperties,
    }).fromJSON;
    function __getBookingsSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.bookings_settings',
            method: 'GET',
            methodFqn: 'wix.bookings.settings.v2.BookingsSettingsService.GetBookingsSettings',
            url: resolveWixBookingsSettingsV2BookingsSettingsServiceUrl({
                protoPath: '/v2/settings',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveWixBookingsSettingsV2BookingsSettingsServiceUrl({
                        protoPath: '/v2/settings',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getBookingsSettings.fromReq = fromReq;
    __getBookingsSettings.__isAmbassador = true;
    return __getBookingsSettings;
}
/**
 * Updates a BookingsSettings.
 *
 * Each time the BookingsSettings is updated,  `revision` increments by 1.
 * The current `revision` must be passed when updating the BookingsSettings.
 * This ensures you're working with the latest BookingsSettings  and prevents unintended overwrites.
 */
export function updateBookingsSettings(payload) {
    var _a = serializer(_updateBookingsSettingsRequest, { _address: _address, _bookingsSettings: _bookingsSettings, _geoCoordinates: _geoCoordinates, _siteProperties: _siteProperties }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateBookingsSettingsResponse, {
        _address: _address,
        _bookingsSettings: _bookingsSettings,
        _geoCoordinates: _geoCoordinates,
        _siteProperties: _siteProperties,
    }).fromJSON;
    function __updateBookingsSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.bookings_settings',
            method: 'PATCH',
            methodFqn: 'wix.bookings.settings.v2.BookingsSettingsService.UpdateBookingsSettings',
            url: resolveWixBookingsSettingsV2BookingsSettingsServiceUrl({
                protoPath: '/v2/bookings-settings',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateBookingsSettings.fromReq = fromReq;
    __updateBookingsSettings.__isAmbassador = true;
    return __updateBookingsSettings;
}
//# sourceMappingURL=http.impl.js.map